import * as i0 from "@angular/core";
export class DisabledModule {
}
DisabledModule.ɵfac = function DisabledModule_Factory(t) { return new (t || DisabledModule)(); };
DisabledModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: DisabledModule });
DisabledModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
